<template>
  <div>
    <section class="section bg-gradient-animated novi-background p-sm-0"
             data-preset='{"title":"Intro","category":"intro","reload":false,"id":"intro-6"}'>
      <div class="container">

        <section class="section " style="margin-top: 0; padding-top: 1em">
          <div class="container">
            <!-- Breadcrumb-->
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link class="breadcrumb-link " to="/">My Account</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link class="breadcrumb-link breadcrumb-active" to="/programs/">Program Select</router-link>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </section>
    <section class="section  novi-background">
      <div class="container">
        <h2 class="text-center">Select your </h2>
        <p>Please select and upload the required documents using the below options. During the different stages of the process we may request different documents from you.</p>
        <p>This may include yours and your partners CV, education qualifications, bank statements, passport copies etc. It is important to us to have accurate and up to date information about you, and your partner to process your application</p>
        <div class="row row-30">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import eoppService from "@/mixins/EoppService";

export default {
  name: "ProgramSelect",
  components: {},
  mixins: [eoppService],
  data() {
    return {
      documents: [],
      uploaded: [],
      toDelete: null
    }
  },
  methods: {
    getDocumentRules: function (doc) {
      //return the list of document rules which required but not yet uploaded
      return (doc.value || []).filter(r => this.uploaded.find(up => up.sub_type === doc.code && up.ref === r.id) === undefined);
    },
    getDocUploads: function (code) {
      return (this.uploaded || []).filter(du => du.sub_type === code).sort((a, b) => a.timeid - b.timeid);
    },
    selectProgram: function (prog) {
      if (this.lead) {
        if (this.lead.cf.pref_program !== prog.code) {
          // this.lead.cf.pref_program = prog.code;
          this.$store.commit('pref_program', prog.code);
          // this.selectedProgram = prog;
          console.log(this.lead.cf.pref_program);
          this.updateCrmRecord([this.lead], null).then(res => {
            this.status = 'SUCCESS';
            console.log(res);
            setTimeout(() => {
              this.status = null;
            }, 2000);
          });
        }
      }
    },
    updateDocuments: function () {
      this.getDocuments();

      // if (this.lead) {
        // if (!this.lead.highlights) {
        //   this.lead.highlights = [];
        // }
        //
        // let docUpd = this.lead.highlights.find(h => h.code === 'doc_updated' );
        //
        // if ( docUpd ) {
        //   docUpd.timeid = Date.now();
        // } else {
        //   this.lead.highlights.push({
        //     code: 'doc_updated',
        //     detail: "Updated",
        //     timeid: Date.now()
        //   });
        // }
        // this.updateCrmRecord([this.lead], null).then(res => {
        //   console.log(res);
        // });
      // }
    },
    getDocuments: function () {
      this.getAccountDocuments().then(res => {
        console.log(res);
        this.documents = res.data.documents;
        this.uploaded = res.data.uploaded;
      })
    },
    deleteDocument: function (doc) {
      this.deleteAccountDocument(doc).then(res => {
        console.log(res);
        // this.documents = res.data.documents;
        let idx = this.uploaded.indexOf(doc);
        if (idx >= 0) {
          this.uploaded.splice(idx, 1);
        }
      })
    }
  },
  mounted() {
    this.getDocuments();
  }
}
</script>

<style scoped>
@media (min-width: 768px) {
  .article-box-large {
    min-height: 22em;
  }
  .article-box-small {
    min-height: 15em;
  }
}
</style>
